import React from "react";
import { Grid, Box } from "@mui/material";
import InfoField from "./InfoField";

import BusinessIcon from "@mui/icons-material/Business";
import BadgeIcon from "@mui/icons-material/Badge";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PlaceIcon from "@mui/icons-material/Place";
import StorefrontIcon from "@mui/icons-material/Storefront";

export default function ClienteSeleccionado({ dataCliente }) {
  if (!dataCliente) return null;

  const {
    razon_social,
    cuit,
    descr_cond_iva,
    direccion_fiscal,
    localidad,
    provincia,
    nombre_sucursal,
  } = dataCliente;

  const ubicacion = [localidad, provincia].filter(Boolean).join(" - ");

  return (
    <Box sx={{ mt: 1 }}>
      <Grid container spacing={2.5}>
        <Grid item xs={12} sm={6} md={4}>
          <InfoField
            icon={<BusinessIcon sx={{ fontSize: 16 }} />}
            label="Razón social"
            value={razon_social?.trim()}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <InfoField
            icon={<BadgeIcon sx={{ fontSize: 16 }} />}
            label="CUIT"
            value={cuit}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <InfoField
            icon={<ReceiptLongIcon sx={{ fontSize: 16 }} />}
            label="Condición IVA"
            value={descr_cond_iva}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <InfoField
            icon={<PlaceIcon sx={{ fontSize: 16 }} />}
            label="Dirección fiscal"
            value={direccion_fiscal}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <InfoField
            icon={<PlaceIcon sx={{ fontSize: 16 }} />}
            label="Localidad / Provincia"
            value={ubicacion}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <InfoField
            icon={<StorefrontIcon sx={{ fontSize: 16 }} />}
            label="Sucursal"
            value={nombre_sucursal}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
